import { bunja } from 'bunja';

import { createPositionOrDismissAtom } from '@flipster/features/src/utils/position-or-dismiss';
import { openPositionsBunja } from '@flipster/r230522/original/position';

import { InstantFlipScope } from './useInstantFlipModal';

export const instantFlipModalBunja = bunja(() => {
  const flipPosition = bunja.use(InstantFlipScope);
  const { openPositionsAtom } = bunja.use(openPositionsBunja);

  const currentPositionAtom = createPositionOrDismissAtom({
    openPositionsAtom,
    symbol: flipPosition?.symbol,
    slot: flipPosition?.slot,
  });

  return { currentPositionAtom };
});
